// RU-STRATDRILL SD-1: renders the one shared strategy drawer opened through openStrategyDrawer().
import { useEffect, useState } from "react";
import StrategyPerformanceDrawer from "@/components/strategy/StrategyPerformanceDrawer";
import { onStrategyDrawer } from "@/lib/strategyDrawer";

export default function StrategyDrawerHost() {
  const [strategy, setStrategy] = useState(null);
  useEffect(() => onStrategyDrawer((s) => setStrategy({ ...s })), []);
  return <StrategyPerformanceDrawer strategy={strategy} onClose={() => setStrategy(null)} />;
}
